var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMissedCall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#FF3239"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6977 11.5889C12.1008 11.9935 12.1008 12.6468 11.6977 13.0514L11.3939 13.4024C8.65895 16.0187 2.00447 9.36588 4.58338 6.62284L4.96689 6.28971C5.37152 5.89807 6.01503 5.90457 6.41154 6.30271C6.42129 6.31246 7.04042 7.11684 7.04042 7.11684C7.4223 7.51822 7.42068 8.14711 7.0388 8.54687L6.65204 9.03275C7.0843 10.0825 7.91631 10.9178 8.96608 11.3517L9.45521 10.9633C9.85497 10.5814 10.4839 10.5798 10.8852 10.9617C10.8852 10.9617 11.688 11.5808 11.6994 11.5905L11.6977 11.5889Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.396 4.99955L13.0566 5.66016L10.4472 8.26955L9.78664 7.60894L12.396 4.99955Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4472 5.00194L13.0566 7.61133L12.396 8.27193L9.78664 5.66254L10.4472 5.00194Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMissedCall);
export default __webpack_public_path__ + "static/media/missedCall.86bf78304968b4e5e5b4b4364c891335.svg";
export { ForwardRef as ReactComponent };